import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

// Material UI
import AppBar from '@material-ui/core/AppBar'
import Badge from '@material-ui/core/Badge'
import Toolbar from '@material-ui/core/Toolbar'
import Drawer from '@material-ui/core/Drawer'
import Typography from '@material-ui/core/Typography'

// Icons
import IconButton from '@material-ui/core/IconButton'
import PhoneIcon from '@material-ui/icons/Phone'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

// Flag Icons
import { IconFlagFR, IconFlagCA } from 'material-ui-flags'

// Components
import Cart from '../Cart/Cart'

// Notification
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'

// Style
import { makeStyles } from '@material-ui/core/styles'

// Redux
import { connect } from 'react-redux'
import { updateLanguage } from '../../redux/actions/clientActions'

const useStyles = makeStyles((theme) => ({
    leftToolbar: {
        marginLeft: -20,
        color: "white"
    },
    rightToolbar: {
        marginLeft: 'auto',
    },
}));

const Header = ({ action, title, languageIcon, phoneIcon, cartIcon, cartData, clientData, storeData, updateLanguage }) => {

    const classes = useStyles()
    const history = useHistory()

    const { store } = storeData
    const { cart } = cartData
    const { language } = clientData

    const [openDrawer, setOpenDrawer] = useState()
    const [cartCount, setCartCount] = useState(0)

    useEffect(() => {
        let count = 0
        cart.forEach(item => {
            count += item.quantity
        })
        setCartCount(count)
    }, [cart, cartCount])

    const toggleDrawer = () => {
        setOpenDrawer(!openDrawer)
    }

    const goBack = () => {
        history.goBack()
    }

    return (
        <>
            <AppBar style={{ position: 'static', backgroundColor: "#003366" }}>
                <Toolbar>

                    {action &&
                        <IconButton className={classes.leftToolbar} onClick={goBack} aria-label="ArrowBackIcon">
                            <ArrowBackIcon />
                        </IconButton>
                    }

                    <Typography variant="h6">{title}</Typography>
                    <section className={classes.rightToolbar}>

                        {languageIcon &&
                            language === "en"
                            ? <IconButton style={phoneIcon ? { paddingRight: 35 } : {}} onClick={() => updateLanguage("fr")}><IconFlagFR /></IconButton>
                            : <IconButton style={phoneIcon ? { paddingRight: 35 } : {}} onClick={() => updateLanguage("en")}><IconFlagCA /></IconButton>

                        }

                        {phoneIcon &&
                            <IconButton href={"tel:" + store.CLIENT_PHONE} color="inherit" style={phoneIcon && cartIcon ? { paddingRight: 35 } : {}} aria-label="PhoneIcon">
                                <PhoneIcon />
                            </IconButton>
                        }

                        {cartIcon &&
                            <Badge onClick={() => toggleDrawer()} badgeContent={cartCount} color="default" aria-label="ShoppingCartIcon">
                                <ShoppingCartIcon />
                            </Badge>
                        }

                    </section>
                </Toolbar>
            </AppBar>
            <Drawer open={openDrawer} anchor="right">
                <Cart toggleDrawer={toggleDrawer} />
            </Drawer>
            <ToastContainer
                style={{ top: 55 }}
                position="top-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        updateLanguage: (language) => dispatch(updateLanguage(language))
    }
}

const mapStateToProps = (state) => {
    return {
        cartData: state.cartData,
        storeData: state.storeData,
        clientData: state.clientData
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)